import React from "react";
import Loader from "components/Loader";
import OutlinedButton from "components/common/Button/OutlinedButton";
import { Input } from "components/common/Input";
import { useLocation, useNavigate } from "react-router-dom";
import { useUserAuth } from "context/authProvider";
import { t } from "i18next";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import axiosInstance from "utils/axios";

const AddKey = () => {
  const { state } = useLocation();
  const { setUser } = useUserAuth();
  const navigate = useNavigate();
  const [inputVales, setInputValues] = React.useState({
    key: "",
    error: "",
    loading: false,
  });

  const { dir } = useAppSelector(getSettings);

  function handleSubmit() {
    setInputValues({ ...inputVales, loading: true });
    axiosInstance.post("keys/validate-key",{
      email: state?.email ?? sessionStorage.getItem("email"),
      key: inputVales.key,
    })
      .then((res) => res.data)
      .then((data) => {
        if (data.statusCode === 200) {
          localStorage.setItem("token", data.data.token);
          setUser(data.data.token);
          navigate(`/response-form/${data.data.user._id || data.data.user.id}`);
          setInputValues({ ...inputVales, loading: false, error: "" });
        } else {
          setInputValues({
            ...inputVales,
            error: data.message,
            loading: false,
          });
        }
      })
      .catch((err) => {
        setInputValues({
          ...inputVales,
          error: err.message ?? "Something went wrong!",
          loading: false,
        });
      });
  }

  return (
    <>
      <Loader open={inputVales.loading} position="portal" />
      <div className="flex flex-col max-w-sm w-full px-6 md:px-0" dir={dir}>
        <div className="flex flex-col gap-4 mb-6">
          {inputVales.error && (
            <p className="text-red-500 text-xs italic">
              {inputVales.error ?? "Something went wrong!"}
            </p>
          )}
          <Input
            id="key"
            type="text"
            placeholder={t("AddKeyInput")}
            value={inputVales.key}
            onChange={(e) =>
              setInputValues({ ...inputVales, key: e.target.value })
            }
          />
        </div>
        <div className="flex flex-col gap-3 items-center justify-center w-full">
          <OutlinedButton onClick={handleSubmit}>{t("AddKeyUnlockButton")}</OutlinedButton>
          <button className="text-gray-600 underline font-medium py-1 px-4 rounded-full focus:outline-none focus:shadow-outline text-sm">
            {t("AddKeyDontHaveKey")}
          </button>
        </div>
      </div>
    </>
  );
};

export default AddKey;
